import { FC, useState, useEffect } from 'react';
import InputLabel from 'raydiant-elements/core/InputLabel';
import InputHelperText from 'raydiant-elements/core/InputHelperText';
import Input from 'raydiant-elements/core/Input';
import Text from 'raydiant-elements/core/Text';
import { PresentationProperty } from '@raydiant/api-client-js';
import {
  getPropertyDefault,
  setPropertyDefault,
} from '../../utilities/properties';
import { useApplicationFormContext } from '../../hooks/useApplicationForm';

interface ApplicationInputDefaultNumberProps {}

const getDefaultValueFromProperty = (property: PresentationProperty | null) => {
  if (!property) return '';

  const defaultValue = parseInt(getPropertyDefault(property), 10);
  if (isNaN(defaultValue)) return '';

  return String(defaultValue);
};

const ApplicationInputDefaultNumber: FC<ApplicationInputDefaultNumberProps> = () => {
  const {
    isEditable,
    version,
    selectedProperty,
    updateSelectedProperty,
  } = useApplicationFormContext();

  // State

  const [defaultValue, setDefaultValue] = useState(
    getDefaultValueFromProperty(selectedProperty),
  );

  // Callbacks

  const handleBlur = () => {
    if (!selectedProperty) return;
    if (!version) return;

    const number = parseInt(defaultValue, 10);
    if (isNaN(number)) return;

    updateSelectedProperty(
      setPropertyDefault(selectedProperty, number),
      version.strings,
    );
  };

  // Effects

  // Reset default value when property changes.
  useEffect(() => {
    setDefaultValue(getDefaultValueFromProperty(selectedProperty));
  }, [selectedProperty]);

  // Render

  return (
    <div>
      <InputLabel>Initial Value</InputLabel>

      {isEditable && (
        <>
          <Input
            type="number"
            value={defaultValue}
            onChange={setDefaultValue}
            onBlur={handleBlur}
          />
          <InputHelperText>The intial value of the input</InputHelperText>
        </>
      )}

      {!isEditable && selectedProperty && (
        <Text>{getPropertyDefault(selectedProperty) || <em>None</em>}</Text>
      )}
    </div>
  );
};

export default ApplicationInputDefaultNumber;
